export class WorkspaceStorageAccessConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "WorkspaceStorageAccessConfigurationAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "WorkspaceStorageAccessConfigurationGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceStorageAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
